import React from 'react'
import dateHelper from '../../util/dateFormatter'
import { Link } from 'react-router-dom';

const ChatPostList = props => {
    if (!props.posts) {
        return (
            <div className='broad'>Loading...</div>
        );
    }

    if (props.posts.length === 0) {
        return (
            <div className='empty'>
                No posts...
      </div>
        );
    }

    return (
        <div>
            <table className="dataTable">
                <thead>
                    <tr>
                        <th>Key</th>
                        <th>Post</th>
                        <th>User</th>
                        <th>Created</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        props.posts.map(item => {
                            return (
                                <tr key={item.key}>
                                    <td className="keyfield"><Link to={`/channels/${props.channelkey}/post/${item.key}`}>{item.key}</Link></td>
                                    <td>{item.post}</td>
                                    <td className="keyfield"><Link to={`/users/${item.userkey}`}>{item.username}</Link></td>
                                    <td>{dateHelper.Formatter.toLocalString(item.created)}</td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
        </div>
    );
};

export default ChatPostList;



// WEBPACK FOOTER //
// ./src/components/widgets/ChatPostList.js